<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          职务管理
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询名称..."
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
    </Tool>
    <div class="content">
      <div style="margin-bottom: 16px; display: flex; align-items: center;">
        <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">新增</a-button>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          bordered
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">

                <span slot="action" slot-scope="text, record">
                      <a @click="handleEdit(record)">编辑</a>
                      <a-divider type="vertical"/>
                      <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                           <a>删除</a>
                      </a-popconfirm>
                </span>

      </a-table>
    </div>
    <PostCreateModal ref="postCreateModal" @ok="loadData"></PostCreateModal>
  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import {TableMixins} from '@/mixins/table-mixins';
import PostCreateModal from "@/components/setting/PostCreateModal";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "Post",
  components: {
    PostCreateModal,
    Tool
  },
  mixins: [HttpMixins, TableMixins],
  data() {
    return {
      columns: [
        {
          title: '职务名称',
          align: "center",
          dataIndex: 'name',
        },
        {
          title: '级别',
          align: "center",
          dataIndex: 'level',
        },
        {
          title: '描述',
          align: "center",
          dataIndex: 'description',
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        list: window._CONFIG['domainURL'] + "/post/list",
        delete: window._CONFIG['domainURL'] + "/post",
        edit: window._CONFIG['domainURL'] + "/post",
        add: window._CONFIG['domainURL'] + "/post",
      }
    }
  },
  methods: {

    handleDelete(id) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
        that.loading = false;
      }
      that.$axios.delete(that.url.delete + "?id=" + id, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },
    handleEdit(record) {
      this.$refs.postCreateModal.edit(record);
    },
    handleAdd() {
      this.$refs.postCreateModal.add();
    },

  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
